module.exports = __webpack_public_path__ + "static/media/flip-h.99b05327.svg";